'use es6';

import Raven from 'Raven';
import get from 'transmute/get';
import { createSelector } from 'reselect';
import { INVALID_DOMAIN_FOR_LINK } from 'MeetingsLib/constants/errors';
var getNetworkErrors = get('networkErrors');

var getResponseJSON = function getResponseJSON(response) {
  if (!response) {
    return null;
  }

  if (response.responseJSON) {
    return response.responseJSON;
  }

  if (response.responseText) {
    var parsed = null;

    try {
      parsed = JSON.parse(response.responseText);
    } catch (e) {
      Raven.captureException(e);
      return parsed;
    }

    return parsed;
  }

  return null;
};

export var getBookInfoError = createSelector([getNetworkErrors], function (networkErrors) {
  var bookInfoError = get('publicAvailabilityInfoFetch', networkErrors);
  var responseJSON = getResponseJSON(bookInfoError);
  return get('errorType', responseJSON) || get('message', responseJSON) || null;
});
export var isInvalidDomainError = createSelector([getBookInfoError], function (bookInfoError) {
  return bookInfoError === INVALID_DOMAIN_FOR_LINK;
});
export var getRescheduleError = createSelector([getNetworkErrors], function (networkErrors) {
  var meetingRescheuduleError = get('meetingReschedule', networkErrors);
  var responseJSON = getResponseJSON(meetingRescheuduleError);
  return get('errorType', responseJSON) || get('message', responseJSON) || null;
});